export const services = [
  {
    slug: "ai-solutions",
    icon: "Ai",
    title: "AI & Machine Learning Solutions",
    short: "Custom AI models, intelligent automation, LLM-powered assistants and predictive analytics that turn your data into a competitive advantage.",
    long: "We design and deploy artificial intelligence that works in the real world: conversational AI agents, computer vision, recommendation engines, document intelligence and forecasting systems. From proof-of-concept to production MLOps, Victrie builds AI solutions that are explainable, secure and measurable.",
    tags: ["LLM Apps", "Chatbots", "Computer Vision", "Predictive Analytics", "MLOps"],
    image: "manager-forecasts",
  },
  {
    slug: "custom-software",
    icon: "Code",
    title: "Custom Software Development",
    short: "Enterprise-grade platforms, SaaS products and internal tools engineered for scale, security and speed.",
    long: "Off-the-shelf software rarely fits. Our engineers build bespoke systems around your exact workflows: ERP and CRM platforms, B2B SaaS, marketplaces, booking systems and automation tools. Every line of code is tested, documented and built to evolve with your business.",
    tags: ["SaaS", "ERP / CRM", "APIs", "Microservices", "Automation"],
    image: "analyzing-data",
  },
  {
    slug: "web-development",
    icon: "Globe",
    title: "Web Application Development",
    short: "Lightning-fast, SEO-optimized websites and progressive web apps built with React, Next.js and modern cloud tooling.",
    long: "Your website is your most important salesperson. We craft high-performance web applications and marketing sites that load in milliseconds, rank on Google and convert visitors into customers. Accessibility, Core Web Vitals and mobile-first design are built in from day one.",
    tags: ["React / Next.js", "PWA", "E-commerce", "Headless CMS", "SEO"],
    image: "office-worker-2",
  },
  {
    slug: "mobile-apps",
    icon: "Mobile",
    title: "Mobile App Development",
    short: "Beautiful native and cross-platform iOS and Android apps that users love and keep coming back to.",
    long: "From fintech wallets and on-demand delivery apps to health platforms and social products, we build mobile experiences with React Native, Flutter, Swift and Kotlin. We handle everything: UX design, backend APIs, payments (M-Pesa, Stripe, cards), push notifications and app-store launch.",
    tags: ["iOS", "Android", "React Native", "Flutter", "M-Pesa Integration"],
    image: "woman-laptop",
  },
  {
    slug: "cloud-devops",
    icon: "Cloud",
    title: "Cloud, DevOps & Infrastructure",
    short: "Scalable, secure cloud architecture on AWS, Azure and Google Cloud with CI/CD pipelines and 99.9% uptime.",
    long: "We migrate, modernize and manage cloud infrastructure so your product scales effortlessly. Kubernetes, serverless, infrastructure-as-code, observability and cost optimization: our DevOps engineers make deployments boring and reliability guaranteed.",
    tags: ["AWS / Azure / GCP", "Kubernetes", "CI/CD", "Serverless", "Monitoring"],
    image: "office-worker-portrait",
  },
  {
    slug: "ui-ux-design",
    icon: "Design",
    title: "UI/UX & Product Design",
    short: "Human-centered product design, design systems and prototypes that make complex technology feel effortless.",
    long: "Great products start with deep understanding. Our designers run user research, map journeys, and craft interfaces that are as intuitive as they are stunning. We deliver design systems, interactive prototypes and pixel-perfect handoffs that engineering teams love.",
    tags: ["User Research", "Prototyping", "Design Systems", "Figma", "Accessibility"],
    image: "design-studio",
  },
  {
    slug: "data-engineering",
    icon: "Data",
    title: "Data Engineering & Analytics",
    short: "Data pipelines, warehouses and real-time dashboards that give leaders the clarity to act.",
    long: "Data is only valuable when it is trusted and accessible. We build modern data platforms: ETL/ELT pipelines, data lakes and warehouses, business intelligence dashboards and real-time streaming analytics, so every decision in your organization is data-driven.",
    tags: ["Data Pipelines", "BI Dashboards", "Warehousing", "Real-time Streaming", "Big Data"],
    image: "couple-project",
  },
  {
    slug: "cybersecurity",
    icon: "Shield",
    title: "Cybersecurity & Compliance",
    short: "Secure-by-design engineering, penetration testing and compliance readiness for regulated industries.",
    long: "Security is not a feature; it is a foundation. We embed security in every layer of your product with threat modeling, secure coding, penetration testing, identity management and compliance with standards such as ISO 27001, GDPR and the Kenya Data Protection Act.",
    tags: ["Pen Testing", "Secure SDLC", "Identity & Access", "GDPR / DPA", "Audits"],
    image: "team-project",
  },
];

export const process = [
  { title: "Discover", text: "We immerse ourselves in your business, users and goals. Workshops, research and technical audits produce a crystal-clear roadmap." },
  { title: "Design", text: "Our product designers turn strategy into wireframes, prototypes and a visual language your customers will remember." },
  { title: "Build", text: "Agile sprints, weekly demos and rigorous code review. You see progress every week and never wonder what is happening." },
  { title: "Launch", text: "Automated testing, security hardening and zero-downtime deployment. We launch with confidence, not hope." },
  { title: "Evolve", text: "Products are never finished. We monitor, optimize and iterate with data so your solution keeps getting better." },
];

export const techStack = [
  "React", "Next.js", "TypeScript", "Node.js", "Python", "Go",
  "React Native", "Flutter", "Swift", "Kotlin", "GraphQL", "PostgreSQL",
  "MongoDB", "Redis", "AWS", "Azure", "Google Cloud", "Kubernetes",
  "Docker", "Terraform", "TensorFlow", "PyTorch", "OpenAI", "LangChain",
];

export const stats = [
  { value: 120, suffix: "+", label: "Products completed" },
  { value: 98, suffix: "%", label: "Client satisfaction" },
  { value: 4, suffix: "+", label: "Countries served" },
  { value: 24, suffix: "/7", label: "Support & monitoring" },
];
